// extracted by mini-css-extract-plugin
export var actions = "_kq-g";
export var benefitCard = "_kq-b";
export var benefitIcon = "_kq-d";
export var benefitLabel = "_kq-f";
export var benefits = "_kq-a";
export var benefitsSection = "_kq-8";
export var bodyText = "_kq-7";
export var closeButton = "_kq-2";
export var content = "_kq-3";
export var eyebrow = "_kq-4";
export var heading = "_kq-5";
export var image = "_kq-i";
export var imagePanel = "_kq-h";
export var modal = "_kq-0";
export var offerCard = "_kq-c";
export var offerIcon = "_kq-e";
export var sectionLabel = "_kq-9";
export var shell = "_kq-1";
export var title = "_kq-6";